import React, { Fragment, useState, useRef, useCallback, useEffect } from 'react';
import { object, string, bool, func } from 'prop-types';

import WeddingImg from '@assets/images/wedding-logo.png';
import CountContainer from './CountContainer';
import ScrollToDown from './ScrollToDown';
import { styWrapper, styHero, styBackground } from './styles';

const DELAY_TIME = 1500;

function WelcomeSection({ location, guestName, type, isAnonymGuest, codeLink, onClickDetail }) {
  const [loading, setLoading] = useState(false);
  const [alreadyDownloadData, setAlreadyDownloadData] = useState(false);
  const isScrollingRef = useRef(false);
  const scrollTimeoutRef = useRef(null);

  // Cleanup timeout khi component unmount
  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  const handleScrollTo = useCallback(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') {
      return;
    }

    // Tránh gọi nhiều lần khi đang scroll
    if (isScrollingRef.current) {
      return;
    }

    // Clear timeout cũ nếu có
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }

    /** scroll into detail view */
    const element = document.getElementById('fh5co-couple');
    if (!element) {
      return;
    }

    // Đánh dấu đang scroll
    isScrollingRef.current = true;

    // Tính toán vị trí scroll
    const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
    const offset = 0; // Có thể điều chỉnh offset nếu cần

    // Sử dụng window.scrollTo với smooth behavior cho cả mobile và desktop
    // Các tối ưu (debounce, requestAnimationFrame) đã đảm bảo performance tốt
    requestAnimationFrame(() => {
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'auto',
      });

      // Reset flag sau khi scroll xong (ước tính thời gian scroll)
      // Trên mobile có thể scroll nhanh hơn, nhưng để 800ms để đảm bảo
      scrollTimeoutRef.current = setTimeout(() => {
        isScrollingRef.current = false;
      }, 800);
    });
  }, []);

  const handleShowDetail = () => {
    if (loading) return undefined;

    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      try {
        const myAudio = document.getElementById('myAudio');
        if (myAudio) {
          myAudio.play();
        }
      } catch {
        console.error('FAILED_TO_PLAY_MUSIC');
      }
    }

    onClickDetail();

    if (!alreadyDownloadData) {
      setLoading(true);

      setTimeout(() => {
        setLoading(false);
        setAlreadyDownloadData(true);
        handleScrollTo();
      }, DELAY_TIME);
    } else {
      handleScrollTo();
    }
  };

  const renderGuestSection = () => {
    if (isAnonymGuest) return <h2 className="to-dearest-name">Trân trọng kính mời</h2>;

    return (
      <Fragment>
        <h3 className="to-dearest">Trân trọng kính mời {type}</h3>
        <h2 className="to-dearest-name">{guestName}</h2>
      </Fragment>
    );
  };

  return (
    <div css={styHero}>
      <header
        id="fh5co-header"
        role="banner"
        className="fh5co-cover"
        css={styBackground}
        data-stellar-background-ratio="0.5"
      >
        <div className="overlay"></div>
        <div className="container">
          <div className="row" css={styWrapper}>
            <div className="col-md-8 col-md-offset-2 text-center">
              <img src={WeddingImg} alt="wedding-dinda-indra" loading="lazy" />
              <h4 className="sub-title">The Wedding of</h4>
              <h1 className="title main-font">Trần Dũng &amp; Khánh Ly</h1>
              <div className={isAnonymGuest ? 'margin__bottom' : ''}>
                <CountContainer />
              </div>
              {renderGuestSection()}
            </div>
          </div>
          <div className="row">
            <ScrollToDown loading={loading} onClick={handleShowDetail} />
          </div>
        </div>
      </header>
    </div>
  );
}

WelcomeSection.propTypes = {
  guestName: string.isRequired,
  isInvitation: bool.isRequired,
  isAnonymGuest: bool.isRequired,
  location: object.isRequired,
  codeLink: string,
  onClickDetail: func.isRequired,
};

WelcomeSection.defaultProps = {
  codeLink: '',
};

export default React.memo(WelcomeSection);
